var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24896 0.300781C6.40497 0.300781 4.07861 2.62881 4.07861 5.47279C4.07861 7.21176 4.95098 8.75169 6.2772 9.68858C3.19001 10.9262 1.00027 13.9457 1.00027 17.468C0.975622 18.5784 2.65397 18.5784 2.62933 17.468C2.62933 13.7292 5.64386 10.7163 9.38259 10.7163C10.6877 10.7163 11.8991 11.0883 12.9302 11.7264C13.8572 12.2949 14.7099 10.9046 13.783 10.3361C13.3187 10.0489 12.8157 9.82485 12.2971 9.63127C13.5773 8.68958 14.4145 7.17719 14.4145 5.47279C14.4145 2.62881 12.0929 0.300781 9.24896 0.300781ZM9.24896 1.93146C11.2125 1.93146 12.7855 3.50921 12.7855 5.47279C12.7855 7.43637 11.2125 9.00763 9.24896 9.00763C7.28538 9.00763 5.70767 7.43637 5.70767 5.47279C5.70767 3.50921 7.28538 1.93146 9.24896 1.93146ZM14.2459 15.7912V17.4202C14.2695 18.4824 15.8514 18.4824 15.875 17.4202V15.7912H17.5056C18.5927 15.7912 18.5927 14.1606 17.5056 14.1606H15.875V12.5315C15.8803 12.0748 15.5092 11.7029 15.0525 11.7074C14.602 11.7104 14.2406 12.081 14.2459 12.5315V14.1606H12.5779C11.4518 14.2126 11.5297 15.8431 12.6168 15.7912H14.2459Z",
    fill: "#0065FC",
    stroke: "#0065FC",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/Followers.de1788c82b6989fa0ba606f2f4c1aa92.svg";
export { ForwardRef as ReactComponent };